// AppContext.js
import React, { createContext, useContext, useState } from 'react';

const AppContext = createContext();

export const useAppContext = () => useContext(AppContext);

export const AppProvider = ({ children }) => {
  // Toast notifications
  const [showToast, setShowToast] = useState(false);
  const [toastContent, setToastContent] = useState({title: "", icon: "", message: ""});

  const displayToast = (content) => {
    setToastContent(content);
    setShowToast(true);
  };

  const closeToast = () => {
    setToastContent({title: "", icon: "", message: ""});
    setShowToast(false);
  };

  return (
    <AppContext.Provider value={{ showToast, toastContent, displayToast, closeToast }}>
      {children}
    </AppContext.Provider>
  );
};